




























































































































































































































































import CompanySideCard from "@/components/company/CompanySideCard.vue";
import PdfViewer from "@/components/files/v2/PdfViewer.vue";
import PersonSideCard from "@/components/person/PersonSideCard.vue";
import RefsCompany from "@/components/utility/RefsCompany.vue";
import RefsInvoice from "@/components/utility/RefsInvoice.vue";
import RefsInvoiceParty from "@/components/utility/RefsInvoiceParty.vue";
import { getFlagEmoji } from "@/lib/CountryCodeHelper";
import { CountryCodeEnum } from "@/lib/enum/country-code.enum";
import { InvoiceStatusEnum } from "@/lib/enum/invoice-status.enum";
import { formatCurrency } from "@/lib/utility/currency-helper";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { InvoiceGoToHelper } from "@/lib/utility/invoice.go-to-helper";
import { $t } from "@/lib/utility/t";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { Address } from "@/models/address.entity";
import { Company, ICompany } from "@/models/company.entity";
import { DocumentDirectionEnum, IInvoice, Invoice } from "@/models/invoice.entity";
import { IPerson, Person } from "@/models/person.entity";
import { IReference } from "@/models/reference.entity";
import { ISignDocument } from "@/models/sign-document.entity";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { BackendResourceEnum, ResourceEnum } from "@/store/enum/authResourceEnum";
import { GroupModule } from "@/store/modules/group.store";
import { PartnerModule } from "@/store/modules/partner";
import { PartnerUserModule } from "@/store/modules/partner-user.store";
import { RefTypeMap } from "@/store/modules/refs.store";
import DocumentSelectionDialog from "@/views/sign/DocumentSelectionDialog.vue";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import LatestEntriesCardEmpty from "../cards/LatestEntriesCardEmpty.vue";
import CostCardDocuments from "../cost/CostCardDocuments.vue";
import GroupTypeSelectionDetailComponent from "../group/GroupTypeSelectionDetailComponent.vue";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";
import MActionList from "../utility/mmmint/MActionList.vue";
import MDetailViewGrid from "../utility/mmmint/MDetailViewGrid.vue";
import MHeader, { IAction, IChips } from "../utility/mmmint/MHeader.vue";
import MNoContent from "../utility/mmmint/MNoContent.vue";
import RefsSelect from "../utility/RefsSelect.vue";
import SelectAssignees from "../utility/SelectAssignees.vue";
import SelectEntity from "../utility/SelectEntity.vue";
import InvoiceFormPreview from "./InvoiceFormPreview.vue";
import { MrfiktivReferenceGen } from "@/services/mrfiktiv/v1/data-contracts";

@Component({
  components: {
    MHeader,
    MDetailViewGrid,
    ActivityCard: () => import("@/components/thg/ActivityCard.vue"),
    RefsInvoice,
    MActionList,
    ConfirmActionDialog,
    RefsSelect,
    CostCardDocuments,
    LatestEntriesCardEmpty,
    SelectAssignees,
    GroupTypeSelectionDetailComponent,
    InvoiceFormPreview,
    SelectEntity,
    RefsCompany,
    RefsInvoiceParty,
    PdfViewer,
    PersonSideCard,
    CompanySideCard,
    MNoContent,
    DocumentSelectionDialog
  },
  filters: {
    getFlagEmoji
  }
})
export default class InvoiceDetail extends mixins(PermissionMixin) {
  readonly InvoiceStatusEnum = InvoiceStatusEnum;
  readonly Invoice = Invoice;
  readonly Address = Address;
  readonly CountryCodeEnum = CountryCodeEnum;
  readonly formable = Invoice;
  readonly DefaultTab = 0;
  readonly formatCurrency = formatCurrency;
  readonly DocumentDirectionEnum = DocumentDirectionEnum;
  readonly RefTypeMap = RefTypeMap;

  @Prop()
  value!: IInvoice;

  @Prop()
  hideBreadCrumbs!: boolean;

  @Prop()
  showDetailButton!: boolean;

  tab = this.DefaultTab;

  personSideCard: IPerson | null = null;

  companySideCard: ICompany | null = null;

  selectedDocuments: ISignDocument[] = [];

  isValid = false;

  isUpdateChangesDialogActive = false;

  isSaveChangesLoading = false;

  isDeleteDialogActive = false;

  isDeleteLoading = false;

  isLoadingRefs = false;

  isLoadingDocumentId = false;

  isLoadingReportId = false;

  isLoadingFleetId = false;

  isLoadingVehicleId = false;

  isLoadingBuildPdf = false;

  isDocumentSelectDialog = false;

  isDocumentOutboundSelectDialog = false;

  pdfPreview: Uint8Array | null = null;

  @Watch("value", { deep: true })
  onValueChanges() {
    this.isUpdateChangesDialogActive = true;
  }

  async abortChanges() {
    await this.value.fetch();
    this.$nextTick(() => {
      this.isUpdateChangesDialogActive = false;
    });
  }

  async saveChanges() {
    this.isSaveChangesLoading = true;
    await this.value
      ?.update()
      .then(res => {
        this.isUpdateChangesDialogActive = false;
        this.value.map(res);
      })
      .catch(handleError);
    this.isSaveChangesLoading = false;
    this.isUpdateChangesDialogActive = false;
  }

  get height() {
    return this.$vuetify.breakpoint.height - 240 + "px";
  }

  get mail() {
    if (this.value.isInbound) {
      return this.value.seller?.email;
    }

    return this.value.buyer?.email;
  }

  get isMobile() {
    return this.$vuetify.breakpoint.mobile;
  }

  get subtitle() {
    return $t("createdOn", { date: simpleDoubleDigitDate(this.value.timestamp.created) });
  }

  get breadCrumbs() {
    if (this.hideBreadCrumbs) {
      return undefined;
    }

    let breadCrumbs = InvoiceGoToHelper.breadCrumbsInbound;
    if (this.value.isOutbound) {
      breadCrumbs = InvoiceGoToHelper.breadCrumbsOutbound;
    }

    const partnerId = this.value.partnerId;
    const invoiceId = this.value.id;

    const selected = [];

    selected.push(breadCrumbs.InvoiceTable({ partnerId }));
    selected.push(breadCrumbs.InvoiceDetail({ partnerId, invoiceId }));

    return selected;
  }

  get chips(): IChips[] {
    const chips: IChips[] = [];

    chips.push({
      text: $t(`enums.InvoiceStatusEnum.${this.value.status}`),
      color: this.value.statusColor,
      key: "status"
    });

    if (this.value.isBilled) {
      chips.push({
        text: $t("objects.invoice.isBilled"),
        color: "success",
        key: "isBilled"
      });
    }

    chips.push({
      text: $t(`enums.DocumentDirectionEnum.${this.value.direction}`),
      key: "direction"
    });

    chips.push({
      text: $t(`enums.InvoiceTypeEnum.${this.value.type}`),
      key: "type"
    });

    chips.push({
      text: formatCurrency(this.value.totalNet, this.value.currency),
      key: "type"
    });

    return chips;
  }

  get actions(): IAction[] {
    const actions: IAction[] = [];

    if (this.showDetailButton) {
      actions.push({
        text: $t("common.nouns.detail"),
        key: "detail",
        icon: "mdi-open-in-new",
        color: "",
        exec: () => this.value.goTo(this.$router).detail()
      });
    }

    if (this.value.status === InvoiceStatusEnum.DRAFT && this.value.isOutbound) {
      actions.push({
        text: $t("invoice.pdf.build"),
        key: "print",
        icon: "mdi-cloud-print-outline",
        color: "",
        exec: this.buildPdf,
        loading: this.isLoadingBuildPdf
      });
    }

    if (this.value.status === InvoiceStatusEnum.DRAFT) {
      actions.push({
        text: $t("delete"),
        key: "delete",
        icon: "mdi-trash-can",
        color: "",
        exec: this.onDeleteItem
      });
    }

    return actions;
  }

  get reference(): MrfiktivReferenceGen {
    return {
      refId: this.value.id,
      refType: BackendResourceEnum.INVOICE
    };
  }

  async buildPdf() {
    this.isLoadingBuildPdf = true;
    await this.value.print().catch(handleError);
    this.isLoadingBuildPdf = false;
  }

  async loadPreview() {
    this.isLoadingBuildPdf = true;
    try {
      const buffer = await this.value.loadPreview();

      this.pdfPreview = new Uint8Array(buffer);
    } catch (e) {
      handleError(e);
    } finally {
      this.isLoadingBuildPdf = false;
    }
  }

  get bottomActions() {
    const actions: IAction[] = [];

    if (this.showDetailButton) {
      actions.push({
        text: $t("common.nouns.detail"),
        key: "detail",
        icon: "mdi-open-in-new",
        color: "",
        exec: () => this.value.goTo(this.$router).detail()
      });
    }

    const groupId = this.value.groupId;
    if (groupId) {
      actions.push({
        text: $t("invoice.toGroup"),
        key: "toGroup",
        icon: "mdi-open-in-new",
        color: "",
        exec: () => this.value.goTo(this.$router).customView()
      });
    }

    if (this.can(ActionEnum.DELETE, BackendResourceEnum.INVOICE)) {
      actions.push({
        text: $t("delete"),
        key: "title",
        icon: "mdi-trash-can",
        color: "red",
        exec: this.onDeleteItem
      });
    }

    return actions;
  }

  get groups() {
    return GroupModule.filteredAndSorted;
  }

  get partner() {
    return PartnerModule.partner;
  }

  get source() {
    return {
      refId: this.value.id,
      refType: BackendResourceEnum.INVOICE
    };
  }

  onDeleteItem() {
    this.isDeleteDialogActive = true;
  }

  getUserNameForId(id: string) {
    const user = PartnerUserModule.maps.id.get(id)[0];

    let name = "";
    if (user) {
      name = `${user.firstName} ${user.lastName}`;
    }

    return name;
  }

  async onDelete() {
    try {
      this.isDeleteLoading = true;

      await this.value.delete();

      this.$toast.success("👍");

      this.isDeleteDialogActive = false;

      this.$emit("deleted");
    } catch (e) {
      handleError(e);
    } finally {
      this.isDeleteLoading = false;
    }
  }

  async saveRefs() {
    this.isLoadingRefs = true;
    await this.value
      .updatePartial({
        refs: this.value.refs
      })
      .catch(handleError);
    this.isLoadingRefs = false;
  }

  async updateVehicleId() {
    this.isLoadingVehicleId = true;
    await this.value
      .updatePartial({
        vehicleId: this.value.vehicleId
      })
      .catch(handleError);
    this.isLoadingVehicleId = false;
  }

  async updateReportId() {
    this.isLoadingReportId = true;
    await this.value
      .updatePartial({
        reportId: this.value.reportId
      })
      .catch(handleError);
    this.isLoadingReportId = false;
  }

  async updateFleetId() {
    this.isLoadingFleetId = true;
    await this.value
      .updatePartial({
        fleetId: this.value.fleetId
      })
      .catch(handleError);
    this.isLoadingFleetId = false;
  }

  async onCreated(document: ISignDocument) {
    this.selectedDocuments = [document];

    this.updateDocumentId();
  }

  async onOutboundDocumentSelected(document: ISignDocument) {
    this.selectedDocuments = [document];

    this.$log.debug(document);

    // TODO: Ask for invoice number and save.

    if (!this.selectedDocuments || !this.selectedDocuments.length) {
      throw new Error("Document missing");
    }

    if (this.value.isOutbound) {
      this.isLoadingDocumentId = true;
      try {
        await this.value.addDocument({
          documentId: document.id,
          number: document.title
        });
      } catch (error) {
        handleError(error);
      } finally {
        this.isLoadingDocumentId = false;
      }
    }
  }

  async updateDocumentId() {
    if (!this.selectedDocuments || !this.selectedDocuments.length) {
      throw new Error("Document missing");
    }

    this.isLoadingDocumentId = true;

    try {
      if (this.value.isInbound) {
        await this.value.updatePartial({
          documentId: this.selectedDocuments[0].id
        });

        await this.value.fetch();
      } else {
        throw Error("Outbound Invoices can not update PDF manually");
      }
    } catch (error) {
      handleError(error);
    } finally {
      this.isLoadingDocumentId = false;
    }
  }

  openAddReference() {
    (this.$refs.refsSelect as RefsSelect)?.open();
  }

  openBuyerSellerSideCard(ref?: IReference) {
    if (!ref) {
      return;
    }

    if (ref.refType === ResourceEnum.PERSON) {
      const element = new Person({
        id: ref.refId,
        partnerId: this.value.partnerId
      });
      this.personSideCard = element;
    } else if (ref.refType === ResourceEnum.COMPANY) {
      const element = new Company({
        id: ref.refId,
        partnerId: this.value.partnerId
      });
      this.companySideCard = element;
    }
  }
}
